/* eslint-disable no-comments/disallowComments */
import React from 'react';
import { styled } from '@mui/material';

/**
 * Bare `<button>` with chrome reset (no background, no border, no outline,
 * inherited font/color, pointer cursor, disabled opacity). Intended as a base
 * for specialized buttons via `styled(RBaseButton)`. Defaults `type="button"`
 * so it doesn't accidentally submit forms when used inside `<form>`.
 */
const StyledBaseButton = styled('button')({
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    color: 'inherit',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'none',
    '&:focus, &:focus-visible': { outline: 'none', boxShadow: 'none' },
    '&:disabled': { opacity: 0.6, cursor: 'not-allowed' },
});

export const RBaseButton = React.forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement>>(
    function RBaseButton(props, ref) {
        return <StyledBaseButton type="button" {...props} ref={ref} />;
    },
);
/* eslint-enable no-comments/disallowComments */
